import React, { Component } from "react";
import { GET, POST, loading, mode, setDarkMode, params } from "../components/CustomComponent.js";
import { loadPrimerloSdk } from "../components/primerloWidget.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";

// หน้ายืนยันตัวตน (KYC) ตัวกลางของเรา ลูกค้ามาจากลิงก์ที่ broker ได้จาก API (kyc_url) หรือจาก error P-4034 ตอนฝาก
// URL: /kyc?t=<token>  ไม่มีชื่อผู้ให้บริการใน URL และหน้าจอ เพราะเราเป็นตัวกลาง
//
// ลำดับ: GET state -> ผ่านแล้ว = done · ยังไม่ผ่าน = POST session -> mount widget -> closed(done) -> GET state อีกรอบ
// สถานะ: none | pending | review | rejected | expired | bank_required | approved

const KYC_LABELS = {
  none: "ยังไม่ได้ยืนยันตัวตน",
  pending: "กำลังตรวจสอบ",
  review: "กำลังตรวจสอบเพิ่มเติม",
  rejected: "ไม่ผ่านการตรวจสอบ",
  expired: "การยืนยันตัวตนหมดอายุ กรุณาทำใหม่",
  bank_required: "ยืนยันตัวตนแล้ว แต่ยังไม่ได้เพิ่มบัญชีธนาคาร",
  approved: "ยืนยันตัวตนเรียบร้อย",
};

export default class Kyc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: params("t") || "",
      // loading | invalid | widget | done | error
      view: "loading",
      info: null,
      error_message: "",
      error_code: "",
      requesting: false,
    };
    this.widget = null;
  }

  async componentDidMount() {
    if (mode === "dark") setDarkMode();
    await this.Start();
  }

  componentDidUpdate() {
    if (mode === "dark") setDarkMode();
  }

  componentWillUnmount() {
    this.DestroyWidget();
  }

  // ---------- API ----------

  GetState = async () => {
    const { token } = this.state;
    if (!token) return null;
    const result = await GET("callback/kyc", { t: token });
    return result?.status && result.data ? result.data : null;
  };

  Start = async () => {
    loading(true);
    const info = await this.GetState();
    loading(false);

    if (!info) {
      this.setState({ view: "invalid" });
      return;
    }

    this.setState({ info });
    if (info.is_ready) return this.setState({ view: "done" });
    await this.RequestSession();
  };

  RequestSession = async () => {
    const { token, requesting } = this.state;
    if (requesting) return;

    this.setState({ requesting: true, error_message: "", error_code: "" });
    loading(true);
    const result = await POST("callback/kyc/session", { t: token });
    loading(false);
    this.setState({ requesting: false });

    if (!result?.status) {
      this.setState({ view: "error", error_message: result?.message || "ไม่สามารถเริ่มการยืนยันตัวตนได้ กรุณาลองใหม่", error_code: result?.data?.code || "" });
      return;
    }

    const data = result.data || {};
    const { mode: nextMode, widget_url, session_id, ...info } = data;
    this.setState({ info: { ...this.state.info, ...info } });

    if (nextMode === "done") return this.setState({ view: "done" });
    if (!widget_url) {
      this.setState({ view: "error", error_message: "ไม่ได้รับลิงก์สำหรับยืนยันตัวตน กรุณาลองใหม่" });
      return;
    }
    this.setState({ view: "widget" }, () => this.MountWidget(widget_url));
  };

  // ---------- widget ----------

  MountWidget = async (url) => {
    this.DestroyWidget();
    try {
      const DealerWidget = await loadPrimerloSdk();
      this.widget = DealerWidget.mount({ url, container: "#kyc-widget", onEvent: this.OnWidgetEvent });
    } catch (err) {
      console.error("mount kyc widget failed:", err?.message || err);
      this.setState({ view: "error", error_message: "โหลดหน้ายืนยันตัวตนไม่สำเร็จ กรุณาลองใหม่" });
    }
  };

  DestroyWidget = () => {
    try {
      if (this.widget?.destroy) this.widget.destroy();
    } catch (e) {}
    this.widget = null;
  };

  OnWidgetEvent = async (m) => {
    if (!m || m.type !== "dealer.widget") return;

    switch (m.event) {
      case "popup_required": {
        // browser ไม่ให้ทำ passkey/LINE ใน iframe ต้องเปิดเป็น popup ด้วย session ใหม่ (ลิงก์เดิมใช้ซ้ำไม่ได้)
        this.DestroyWidget();
        const { token } = this.state;
        loading(true);
        const result = await POST("callback/kyc/session", { t: token });
        loading(false);
        if (result?.status && result.data?.widget_url && window.DealerWidget?.open) {
          this.widget = window.DealerWidget.open({ url: result.data.widget_url, onEvent: this.OnWidgetEvent });
        } else if (result?.status && result.data?.mode === "done") {
          this.setState({ view: "done" });
        } else {
          this.setState({ view: "error", error_message: "เบราว์เซอร์นี้ไม่รองรับการยืนยันตัวตนในหน้านี้ กรุณาเปิดด้วย Chrome หรือ Safari" });
        }
        break;
      }

      case "error":
        this.setState({ view: "error", error_message: m.data?.message || "ไม่สามารถดำเนินการต่อได้", error_code: m.data?.code || "" });
        break;

      case "closed": {
        this.DestroyWidget();
        // done = ทำใน widget เสร็จ (ยืนยันตัวตน/เพิ่มบัญชี) ถามสถานะล่าสุดอีกรอบ ถ้ายังไม่ครบจะได้ widget รอบใหม่
        if (m.data?.reason === "done") return this.Start();
        this.setState({ view: "error", error_message: "การยืนยันตัวตนยังไม่เสร็จ กดลองใหม่เพื่อทำต่อ" });
        break;
      }

      default:
        break;
    }
  };

  // ---------- render ----------

  renderBody = () => {
    const { view, info, error_message, error_code } = this.state;
    const returnUrl = info?.return_url;
    const statusLabel = KYC_LABELS[info?.kyc_status] || info?.kyc_status || "-";

    switch (view) {
      case "loading":
        return null;

      case "invalid":
        return <div className="alert alert-warning">ลิงก์ไม่ถูกต้องหรือหมดอายุ กรุณาขอลิงก์ยืนยันตัวตนใหม่จากร้านค้า</div>;

      case "widget":
        return (
          <div>
            <div className="alert alert-info py-2">
              <small>
                เข้าสู่ระบบด้วย Passkey หรือ LINE แล้วทำตามขั้นตอนในกรอบด้านล่างให้ครบ (ยืนยันตัวตนและเพิ่มบัญชีธนาคารในชื่อของคุณ)
                เมื่อเสร็จแล้วจะสามารถทำรายการฝากได้ตามปกติ
              </small>
            </div>
            <div id="kyc-widget" className="w-100 mb-3" />
          </div>
        );

      case "done":
        return (
          <div>
            <div className="alert alert-success">ยืนยันตัวตนเรียบร้อยแล้ว คุณสามารถกลับไปทำรายการฝากได้ทันที</div>
            {returnUrl && (
              <a className="btn btn-success w-100" href={returnUrl}>
                กลับไปยังร้านค้า
              </a>
            )}
          </div>
        );

      case "error":
      default:
        return (
          <div>
            <div className="alert alert-danger">
              {error_message}
              {error_code ? <small className="d-block text-secondary mt-1">รหัส: {error_code}</small> : null}
            </div>
            <div className="mb-3">
              <small className="text-secondary">สถานะปัจจุบัน: {statusLabel}</small>
            </div>
            <button type="button" className="btn btn-warning w-100 mb-2" onClick={this.Start}>
              ลองใหม่
            </button>
            {returnUrl && (
              <a className="btn btn-outline-secondary w-100" href={returnUrl}>
                กลับไปยังร้านค้า
              </a>
            )}
          </div>
        );
    }
  };

  render() {
    const { info } = this.state;
    return (
      <div className="w-100 min-vh-100 background position-relative auth-scope">
        <div className="row w-100 mx-0">
          <div className={`col-12 d-flex align-items-center justify-content-center d-md-none auth-brand py-3`}>
            <img alt="logo" src={LOGO} className="w-75" style={{ minWidth: 350 }} />
          </div>
          <div className={`col-6 d-none d-md-flex align-items-center justify-content-center auth-brand min-vh-100`}>
            <img alt="logo" src={LOGO} style={{ width: "60%", minWidth: 400 }} />
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="col-11 col-md-10 col-lg-8 col-xl-7 mx-auto my-5 auth-card">
              <div className="d-flex align-items-center mb-2">
                <h3 className="fw-bold text-dark mb-0 me-2">ยืนยันตัวตน</h3>
              </div>
              <div className="mb-3">
                <small>
                  {info?.broker?.name_th || info?.broker?.name_en ? `ร้านค้า: ${info.broker.name_th || info.broker.name_en} · ` : ""}
                  การยืนยันตัวตนทำครั้งเดียว ใช้ได้กับทุกรายการฝากหลังจากนี้
                </small>
              </div>

              {this.renderBody()}

              <div className="w-100 text-center mt-3">
                <small className="text-secondary text-center">
                  Copyright © 2025 SwiftGoldPay version {global.version}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
